

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedServiceService } from '../services/shared-service.service';

@Injectable({ providedIn: 'root' })
export class MemberTargetsService {

  private apiBaseUrl: string;

  constructor(private http: HttpClient, private sharedService: SharedServiceService) {
    this.apiBaseUrl = sharedService.baseUrl();
  }

  saveMemberTargetsBatchByMember(payload: { memberId: string, targets: Array<{ component: string, target: string, unit: string }> }): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.post(`${this.apiBaseUrl}member-targets/batch`, payload, { headers });
  }

  getMemberTargetsList(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.get(`${this.apiBaseUrl}member-targets?memberId=${memberId}`, { headers });
  }

  markTargetAsComplete(memberId: string, component: string, status: string = 'Completed'): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.post(`${this.apiBaseUrl}member-targets/complete`, { memberId, component, status }, { headers });
  }

  getTargetsHist(memberId: string, component?: string, startDate?: string, endDate?: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    let url = `${this.apiBaseUrl}member-targets/history?memberId=${memberId}`;
    if (component) {
      url += `&component=${encodeURIComponent(component)}`;
    }
    if (startDate) {
      url += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate) {
      url += `&endDate=${encodeURIComponent(endDate)}`;
    }
    return this.http.get(url, { headers });
  }
}

